/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";
import {
  TreasuryAccountBalances,
  TreasuryAccountBalances$inboundSchema,
  TreasuryAccountBalances$Outbound,
  TreasuryAccountBalances$outboundSchema,
} from "./treasuryaccountbalances.js";

/**
 * AccountBalance rest response schema
 */
export type ListAccountBalancesResponse = {
  data: Array<TreasuryAccountBalances>;
};

/** @internal */
export const ListAccountBalancesResponse$inboundSchema: z.ZodType<
  ListAccountBalancesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(TreasuryAccountBalances$inboundSchema),
});

/** @internal */
export type ListAccountBalancesResponse$Outbound = {
  data: Array<TreasuryAccountBalances$Outbound>;
};

/** @internal */
export const ListAccountBalancesResponse$outboundSchema: z.ZodType<
  ListAccountBalancesResponse$Outbound,
  z.ZodTypeDef,
  ListAccountBalancesResponse
> = z.object({
  data: z.array(TreasuryAccountBalances$outboundSchema),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountBalancesResponse$ {
  /** @deprecated use `ListAccountBalancesResponse$inboundSchema` instead. */
  export const inboundSchema = ListAccountBalancesResponse$inboundSchema;
  /** @deprecated use `ListAccountBalancesResponse$outboundSchema` instead. */
  export const outboundSchema = ListAccountBalancesResponse$outboundSchema;
  /** @deprecated use `ListAccountBalancesResponse$Outbound` instead. */
  export type Outbound = ListAccountBalancesResponse$Outbound;
}

export function listAccountBalancesResponseToJSON(
  listAccountBalancesResponse: ListAccountBalancesResponse,
): string {
  return JSON.stringify(
    ListAccountBalancesResponse$outboundSchema.parse(
      listAccountBalancesResponse,
    ),
  );
}

export function listAccountBalancesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListAccountBalancesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAccountBalancesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAccountBalancesResponse' from JSON`,
  );
}
